import React from 'react';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={require('../img/roku.png')} {...props} />
);

export default Badge;
